import type {
  PartnerAddressBook,
  PartnerAddressBookCreate,
  PartnerAddressBookDocument,
  PartnerAddressBookPatch,
  PartnerSearchAddressBooksParams,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const addressBook = {
  search: {
    queryKey: 'partner-management-service/addressBook',
    configurationType: 'default' as const,
    fn: async (params: PartnerSearchAddressBooksParams = {}) => {
      const { data } = await GatewayAxiosClient.get<PartnerAddressBookDocument[]>(
        '/partner-management-proxy/api/v1/partners/book/addresses/search',
        { params },
      );

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/addressBook/id',
    configurationType: 'no-cache' as const,
    fn: async (addressId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerAddressBook>(
        `/partner-management-proxy/api/v1/partners/book/addresses/${addressId}`,
      );

      return data;
    },
  },
  delete: async (addressId: string) => {
    const { data } = await GatewayAxiosClient.delete<PartnerAddressBook>(
      `/partner-management-proxy/api/v1/partners/book/addresses/${addressId}`,
    );
    return {
      data,
      invalidateQueryKeys: [
        ['partner-management-service/addressBook'],
        ['partner-management-service/addressBook/id', addressId],
      ],
    };
  },
  update: async ({ addressId, payload: payload }: { addressId: string; payload: PartnerAddressBookPatch }) => {
    const { data } = await GatewayAxiosClient.patch<PartnerAddressBook>(
      `/partner-management-proxy/api/v1/partners/book/addresses/${addressId}`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [
        ['partner-management-service/addressBook'],
        ['partner-management-service/addressBook/id', addressId],
      ],
    };
  },
  create: async (addressCreate: PartnerAddressBookCreate) => {
    const { data } = await GatewayAxiosClient.post<PartnerAddressBook>(
      '/partner-management-proxy/api/v1/partners/book/addresses',
      addressCreate,
    );

    return { data, invalidateQueryKeys: [['partner-management-service/addressBook']] };
  },
};
